import { Component, OnInit, Input, AfterViewInit, ElementRef } from '@angular/core';
import { ConteudoCaminho } from '../cabecalho-conteudo/conteudo-caminho';
import { Router, NavigationStart, NavigationEnd, ActivatedRoute, ActivatedRouteSnapshot } from '@angular/router';
import { switchMap, filter } from 'rxjs/operators';
import { Title } from '@angular/platform-browser';
import { combineLatest } from 'rxjs';

@Component({
  selector: 'app-armacao',
  templateUrl: './armacao.component.html',
  styleUrls: ['./armacao.component.less']
})
export class ArmacaoComponent implements AfterViewInit {
  displayStatus = 'hidden';

  @Input()
  titulo: string = '';

  @Input()
  subtitulo: string = '';

  @Input()
  conteudoCaminho: ConteudoCaminho[] = [];

  @Input()
  conteudoId: string = '';
  
  carregandoFrame: boolean = true;

  constructor(public el: ElementRef, 
    private router: Router, 
    private titleService: Title,
    private activatedRoute: ActivatedRoute) { }

  ngAfterViewInit(): void {
    this.revincularEventos();
    //console.log('RENDERED ARMARCAO');
  }

  revincularEventos(): void {
    setTimeout(() => {
      $('[data-widget="tree"]').each(function () {
        ($(this) as any).tree();
      });

      ($('body') as any).layout();

      setTimeout(() => {
        this.carregandoFrame = false;
        this.displayStatus = 'visible';
      }, 1000);
    }, 0);
  }
}
